
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "id": "图像_16",
    "data-name": "图像 16",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 20 20"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "标注"
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "marking"
      },
      "children": [
        {
          "tag": "rect",
          "attrsMap": {
            "width": "20",
            "height": "20",
            "rx": "3",
            "ry": "3",
            "style": "fill:#5397ff"
          }
        }
      ]
    },
    {
      "tag": "polygon",
      "attrsMap": {
        "points": "11 15 8.7 16.9 17 17 17 15 11 15",
        "style": "fill:#fff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M10.2,6.6,4,12.8A2.8,2.8,0,0,0,3,15c0,1.2.1,2,.1,2H6c.3,0,.7-.5,1.3-1.1l6.1-6.1Z",
        "transform": "translate(0 0)",
        "style": "fill:#fff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M16.5,4.8,15.1,3.4a1.3,1.3,0,0,0-1.8.1h0L11.6,5.2l3.3,3.3,1.7-1.7h0A1.4,1.4,0,0,0,16.5,4.8Z",
        "transform": "translate(0 0)",
        "style": "fill:#fff"
      }
    }
  ]
})
    }
  